
import ShieldSecurity from "../../../assets/filled/ShieldSecurity.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShieldSecurityIcon({ className, dataTestid = "ShieldSecurityIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShieldSecurity data-testid={dataTestid} className={classes} {...rest} />
  );
}
